import { Column, Row, Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';
import { Divider } from '~/commonComponents';

import { TNullable } from '~/types/Nullable';
import { formatExperienceDates, formatGraduationDate } from '../../utils';
import { OutlineAcademicCapIcon, OutlineOfficeBuildingIcon } from '@tempmee/react-icons';

interface IResumePreviewProps {
  educations: IEducation[];
  experiences: IExperience[];
  professionalName: string;
  summaries: string;
}

interface IEducation {
  graduatesAt: TNullable<string>;
  institutionName: string;
}

interface IExperience {
  employerName: string;
  endsAt: TNullable<string>;
  isCurrentEmployer: boolean;
  startsAt: string;
  title: string;
}

export const ResumePreview = ({
  educations,
  experiences,
  professionalName,
  summaries,
}: IResumePreviewProps) => {
  return (
    <Column data-testid="candidate-resume">
      <Column gap={2} data-testid="about-section">
        <Typography as="span" bold size="heading_4">
          About {professionalName}:
        </Typography>
        <Typography as="span">{summaries}</Typography>
      </Column>

      <Divider height={2} marginVertical={22} width={'90%'} />

      <Column gap={3} data-testid="experience-section">
        <Typography as="span" bold size="heading_4">
          Professional Experience:
        </Typography>
        <Column gap={5}>
          {experiences?.map((it, index) => (
            <Row key={`${it.employerName}-${index}`} gap={1} data-testid="experience-item">
              <OutlineOfficeBuildingIcon size={24} color={colors.secondary[500]} />
              <Column>
                <Typography as="span" variant="body1">
                  <Typography as="span" bold variant="body1">
                    {it.employerName}
                  </Typography>{' '}
                  - {it.title}
                </Typography>
                <Typography italic color={colors.neutral[500]}>
                  {formatExperienceDates(it.startsAt, it.endsAt, it.isCurrentEmployer)}
                </Typography>
              </Column>
            </Row>
          ))}
        </Column>
      </Column>

      <Divider height={2} marginVertical={22} width={'90%'} />

      <Column gap={3} data-testid="education-section">
        <Typography as="span" bold size="heading_4">
          Highest Level of Education:
        </Typography>
        {educations?.map((it, index) => (
          <Row key={`${it.institutionName}-${index}`} gap={1} data-testid="education-item">
            <OutlineAcademicCapIcon size={24} color={colors.secondary[500]} />
            <Column>
              <Typography as="span" bold variant="body1">
                {it.institutionName}
              </Typography>
              <Typography italic color={colors.neutral[500]}>
                Graduation Date: {formatGraduationDate(it.graduatesAt)}
              </Typography>
            </Column>
          </Row>
        ))}
      </Column>
    </Column>
  );
};
